import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'kiloFormatPipe',
})
export class kiloFormatPipe implements PipeTransform {
    transform(value: any, minValue: any) {
        let roundedResult = '';
        if (value >= minValue) {
            let result = value / 1000;
            if (result % 1 != 0) {
                roundedResult = result.toFixed(1);
                return roundedResult + 'k';
            }
            return result + 'k';
        } else {
            return value;
        }
    }
}